import type { MetricRange } from '@/schemas/commons';
import { useMetrics } from '@/services/Metrics';
import { usePricing } from '@/services/Pricing';

export const useCostsData = (range: MetricRange) => {
	const metrics = useMetrics({ range });
	const pricing = usePricing();

	return {
		metrics,
		pricing,
		isLoading: metrics.isLoading || pricing.isLoading,
		isError: metrics.isError || pricing.isError,
	};
};
